<!-- <div class="custombg fixed-top">
  <app-header></app-header>
</div> -->
<div class="wrapper home-component">
  <div class="row col-12 col-md-12 mt-4">
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Sales')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/case-studies.png" /></div>
          <div class=title>Case Studies</div>
        </div>
        <div class="description mt-4">
          Case study is an in-depth examination of a particular situation or phenomenon and to gain insights and
          understandings.
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Templates')"
      [class.disable]="!isAuthorizedUser('Template')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/Templates-icon.png" /></div>
          <div class=title>Templates</div>
        </div>
        <div class="description mt-4">
          Template document is a pattern that can be used as a guide to fasten the task and produce required finished
          document.
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Proposal')"
      [class.disable]="!isAuthorizedUser('Proposal')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/Proposal-Repository-icon.png" />
          </div>
          <div class=title>Proposal Repository</div>
        </div>
        <div class="description mt-4">
          Proposal repository is a store of the submitted client proposals which can be used as a reference to create
          new proposals.
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Account')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/account-Planning-icon.png" /></div>
          <div class=title>Account Planning</div>
        </div>
        <div class="description mt-4">
          Account planning is the place to map out important details about a new prospect or existing customer along
          with decision making process.
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Competencies')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/competency-icon.png" /></div>
          <div class=title>Competencies</div>
        </div>
        <div class="description mt-4">
          Competencies are the knowledge, skills and abilities that contribute to individual and organizational
          performance
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-3 col-md-3 individual-menu-card" (click)="pageNavigate('Skills')"
      [class.disable]="!isAuthorizedUser('Skill')">
      <mat-card-content>
        <div class="card-title d-flex">
          <div class="image mr-2"><img class="icon-home" src="../../../assets/images/skill-repository-icon.png" /></div>
          <div class=title>Skill Repository</div>
        </div>
        <div class="description mt-4">
          Skill repository is a comprehensive list of all the experiences, professional skills of employees in an
          organization.
        </div>
        <div class="link-section d-flex mt-4">
          <div class="learn-more">
            Learn More
          </div>
          <div class="icon-container ml-2">
            <mat-icon class="icon">play_arrow</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>